import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import classes from './index.module.scss'

export const HighlightItem = ({
  item,
  isWarningWhenNotHasPanel,
  setIsShowPopupWarning,
}) => {
  const scrollToElement = () => {
    const scrollDiv = document.querySelector(
      '#companyAnalysis .scrollbars div:first-child',
    )
    const scrollElement = item.scrollElementClass
      ? document.getElementsByClassName(item.scrollElementClass)?.[0]
      : document.getElementById(item.scrollElementId)

    if (scrollDiv && scrollElement) {
      scrollDiv.scrollTo({
        top: scrollElement.offsetTop,
        behavior: 'smooth',
      })
    }

    if (!scrollElement && isWarningWhenNotHasPanel) {
      setIsShowPopupWarning(true)
    }
  }

  const handleDetailClick = () => {
    if (item.onDetailClick) {
      item.onDetailClick(scrollToElement)
    } else {
      scrollToElement()
    }
  }

  return (
    <div className={classes.highlightWrap}>
      <Element
        className={classes.title}
        style={{
          color: '#3a414b',
          fontSize: 14,
        }}
      >
        {item.isI18n ? <Translate value={item.title} /> : item.title}
      </Element>
      <Element
        className={classes.detail}
        style={{
          color: '#0553a5',
          fontSize: 14,
        }}
        onClick={handleDetailClick}
      >
        {item.formatVal ? item.formatVal(item.detail) : item.detail}
      </Element>
    </div>
  )
}
